import { useEffect, useState } from "react";

import Header from '../components/header';
import Footer from '../components/footer';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const API_ROOMS = `${BASE_URL}getpagedata/get_roomlist_home.php`;
const ROOM_IMG = `${BASE_URL}admin/assets/room_gallery/`;
const ENQUIRY = `${BASE_URL}getpagedata/save-enquiry.php`;

const Rooms = () => {

  // -------------------------
  // ROOM STATES
  // -------------------------
  const [rooms, setRooms] = useState([]);
  const [roomLoading, setRoomLoading] = useState(true);
  const [error, setError] = useState(null);

  // -------------------------
  // ENQUIRY STATES
  // -------------------------
  const [form, setForm] = useState({
    fullname: "",
    email: "",
    contact: "",
    address: "",
    message: ""
  });

  const [enquiryLoading, setEnquiryLoading] = useState(false);

  // -------------------------
  // HANDLE INPUT CHANGE
  // -------------------------
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // -------------------------
  // FETCH ROOMS
  // -------------------------
  useEffect(() => {

    fetch(API_ROOMS)
      .then(res => {
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
        return res.json();
      })
      .then(data => {
        if (data.status && Array.isArray(data.data)) {
          setRooms(data.data);
        } else {
          setRooms([]);
        }
        setRoomLoading(false);
      })
      .catch(err => {
        console.error("Fetch error:", err);
        setError("Unable to load rooms.");
        setRoomLoading(false);
      });

  }, []);

  // -------------------------
  // HANDLE ENQUIRY SUBMIT
  // -------------------------
  const handleSubmit = async () => {

    if (!form.fullname || !form.email || !form.contact) {
      alert("Please fill required fields");
      return;
    }

    setEnquiryLoading(true);

    try {
      const res = await fetch(ENQUIRY, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(form)
      });

      const data = await res.json();

      if (data.status === "success") {
        alert("Enquiry submitted successfully!");

        setForm({
          fullname: "",
          email: "",
          contact: "",
          address: "",
          message: ""
        });

      } else {
        alert("Error saving enquiry");
      }

    } catch (err) {
      console.error(err);
      alert("Server error");
    }

    setEnquiryLoading(false);
  };
  return (
    <div>
        <Header />
      <>
      {/* Button to Open Modal */}
      <button
        className="btn btn-warning"
        data-bs-toggle="modal"
        data-bs-target="#enquiryModal"
      >
        Make an Enquiry
      </button>

      {/* Modal */}
      <div
        className="modal fade"
        id="enquiryModal"
        tabIndex="-1"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content shadow-lg border-0 rounded-4">

            <div className="modal-header bg-dark text-white rounded-top-4">
              <h5 className="modal-title">Hotel Enquiry</h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body p-4">

              <div className="row g-3">

                <div className="col-md-6">
                  <input
                    type="text"
                    name="fullname"
                    placeholder="Full Name *"
                    className="form-control"
                    value={form.fullname}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email *"
                    className="form-control"
                    value={form.email}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <input
                    type="tel"
                    name="contact"
                    placeholder="Contact No *"
                    className="form-control"
                    pattern="[0-9]{10}"
                    value={form.contact}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <input
                    type="text"
                    name="address"
                    placeholder="Address"
                    className="form-control"
                    value={form.address}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-12">
                  <textarea
                    name="message"
                    rows="4"
                    placeholder="Your Message"
                    className="form-control"
                    value={form.message}
                    onChange={handleChange}
                  ></textarea>
                </div>

              </div>

            </div>

            <div className="modal-footer">
              <button
                className="btn btn-dark w-100"
                onClick={handleSubmit}
                disabled={roomLoading}
              >
                {roomLoading ? "Submitting..." : "Submit Enquiry"}
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
	<div className="section big-55-height over-hide z-bigger">
	
		<div className="parallax parallax-top" style={{ backgroundImage: `url('/img/3.jpeg')` }}></div>
		<div className="dark-over-pages"></div>
	
		<div className="hero-center-section pages">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-12 parallax-fade-top">
						<div className="hero-text">Our Rooms</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	
	{/* <div className="section padding-top-bottom-smaller background-dark over-hide z-too-big">
		<div className="section">		
			<div className="container">
				<div className="row">
					<div className="col-md-12">
						<div className="row justify-content-center">
							<div className="col-md-6 col-xl-4 px-sm-0">
								<div className="booking-sep-wrap">
									<div className="input-daterange input-group" id="flight-datepicker-1">
										<div className="form-item">
											<span className="fontawesome-calendar"></span>
											<input className="input-sm" type="text" autocomplete="off" id="start-date" name="start" placeholder="check-in" data-date-format="DD, MM d"/>
											<span className="date-text date-depart"></span>
										</div>
										<div className="form-item">
											<span className="fontawesome-calendar"></span>
											<input className="input-sm" type="text" autocomplete="off" id="end-date" name="end" placeholder="check-out" data-date-format="DD, MM d"/>
											<span className="date-text date-return"></span>
										</div>
									</div>	
								</div>
							</div>
							<div className="col-md-3 col-xl-2 px-sm-0">
								<div className="quantity">
									<input type="number" min="1" max="9999" step="1" value="1" />
								</div>	
							</div>	
							<div className="col-md-3 col-xl-2 px-sm-0">
								<a className="booking-button-big" href="search.html">check<br/>availability</a>
							</div>	
						</div>	
					</div>
				</div>
			</div>					
		</div>
	</div> */}
 

 <div className="container py-5">
{roomLoading && <p>Loading rooms...</p>}
      {error && <p className="text-danger">{error}</p>}
      
    {rooms.map(room => {
      const amenities = room.amenities
        ? room.amenities.split(", ")
        : [];

        return (
          <div className="card booking-list-card mb-4" key={room.id}>
            <div className="row g-0">

              {/* IMAGE */}
              <div className="col-lg-3">
                <img
                  src={`${ROOM_IMG}${room.room_image}`}
                  className="img-fluid w-100 list-img"
                  alt={room.name}
                />
              </div>

              {/* DETAILS */}
              <div className="col-lg-6 p-4 d-flex flex-column">

                <div className="d-flex justify-content-between">
                  <h5 className="property-title">{room.name}</h5>
                 <div className="hotel-rating">5 ★</div>
                </div>

                 <div className="small text-muted mb-3" style={{ fontWeight: "bold" }}>
                  Free Cancellation available
                </div>

                <div className="small mb-3" dangerouslySetInnerHTML={{ __html: room?.description || "" }}>
                </div>

                <div className="mt-auto text-success small">
                 {amenities.map((a, index) => (
                  <span key={index} className="me-3">
                   &nbsp; <i className="bi bi-check-circle"></i> &nbsp;
                    {typeof a === "string" ? a.trim() : a.name}
                  </span>
                ))}
                </div>
              </div>

              {/* PRICE */}
              <div className="col-lg-3 p-4 d-flex flex-column justify-content-between text-end bg-light">

                <div>
                  <small className="text-muted">
                    1 night • 1 adults
                  </small>
                  <h4 className="text-danger">Rs.{room.price}</h4>
                  <small className="text-muted">
                    Includes taxes & fees
                  </small>
                </div>

                <div>
                 <a className="btn btn-primary w-100"
                    href={`https://wwwhotelpahadiconvention.bookingjini.in/`}>
                    See Availability
                  </a>            
                </div>

                  <div>
               <button
              className="btn btn-primary w-100"
              data-bs-toggle="modal"
              data-bs-target="#enquiryModal"
            >
              Quick Enquiry
            </button>     
                </div>
              </div>

            </div>
          </div>
        );
      })}

</div>
	
	<div className="section background-dark over-hide">
        <div className="container-fluid py-4">
            <div className="row">
                <div className="col-sm-6 col-lg-4">
                    <a href="/rooms">
                        <div className="img-wrap services-wrap">
                            <img src="img/ser1.png" alt=""/>
                            <div className="services-text-over">Rooms</div>
                        </div>
                    </a>
                </div>
                <div className="col-sm-6 col-lg-4 pt-4 pt-sm-0">
                    <a href="/dinein">
                        <div className="img-wrap services-wrap">
                            <img src="img/ser2.png" alt=""/>
                            <div className="services-text-over">restaurant</div>
                        </div>
                    </a>
                </div>
               
                <div className="col-sm-6 col-lg-4 pt-4 pt-lg-0">
                    <a href="/banquet">
                        <div className="img-wrap services-wrap">
                            <img src="img/ser4.png" alt=""/>
                            <div className="services-text-over">Banquet</div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
	
    <br></br>
    <Footer />
    </div>
  )
}

export default Rooms;